module.exports = __webpack_public_path__ + "static/media/BIO.b72b9091.png";